var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "p-3 mt-2 bg-white shadow-sm" },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "11" } },
        [
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  staticClass: "text-center text-primary",
                  attrs: { "vs-lg": "1" }
                },
                [
                  _c("div", [_vm._v(" # "), _c("br")]),
                  _c(
                    "div",
                    {
                      staticClass: "cursor-pointer",
                      class: { "text-success": _vm.wasCopied },
                      on: {
                        click: function($event) {
                          return _vm.copyToClipboard(
                            _vm.file.febosId,
                            _vm.file.numero
                          )
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.file.numero) + " ")]
                  )
                ]
              ),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "2" } },
                [
                  _vm.file.estado.toString() === _vm.FileStates.DISMISSED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Desestimado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "mail_outline", color: "#4e94e0" }
                          }),
                          _vm._v(" Desestimado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.estado.toString() === _vm.FileStates.PREPARED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Preparado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "query_builder", color: "#4e94e0" }
                          }),
                          _vm._v(" Preparado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.estado.toString() === _vm.FileStates.INITIATED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Iniciado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "access_time", color: "#43C3B9" }
                          }),
                          _vm._v(" Iniciado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.estado.toString() === _vm.FileStates.APPROVED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Aprobado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "thumb_up", color: "#28c76f" }
                          }),
                          _vm._v(" Aprobado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.estado.toString() === _vm.FileStates.REJECTED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Rechazado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "thumb_down", color: "#ea5455" }
                          }),
                          _vm._v(" Rechazado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.estado.toString() === _vm.FileStates.CANCELED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Anulado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "move_to_inbox", color: "#ea5455" }
                          }),
                          _vm._v(" Anulado ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "9" } },
                [
                  _c(
                    "vs-row",
                    [
                      _c(
                        "vs-col",
                        {
                          attrs: { "vs-lg": "4", "vs-sm": "4", "vs-xs": "12" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm.findTypeDocument(_vm.file.numeroInt)
                                )
                              ) +
                              " "
                          ),
                          _c("span", [
                            _c("b", [_vm._v("# " + _vm._s(_vm.file.numeroExt))])
                          ])
                        ]
                      ),
                      _c(
                        "vs-col",
                        {
                          attrs: { "vs-lg": "4", "vs-sm": "4", "vs-xs": "12" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("capitalize")(_vm.file.solicitanteNombre)
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "vs-col",
                        {
                          attrs: { "vs-lg": "4", "vs-sm": "4", "vs-xs": "12" }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.file.receptorContactoNombre) + " "
                          ),
                          _vm.file.estado === _vm.FileStates.APPROVED
                            ? _c(
                                "small",
                                { staticClass: "d-block text-success" },
                                [_vm._v(" Aprobó ")]
                              )
                            : _vm._e(),
                          _vm.file.estado === _vm.FileStates.REJECTED
                            ? _c(
                                "small",
                                { staticClass: "d-block text-danger" },
                                [_vm._v(" Rechazó ")]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  attrs: { "vs-offset": "3", "vs-lg": "7", "vs-type": "flex" }
                },
                [
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Fecha inicio del proceso",
                          expression: "'Fecha inicio del proceso'"
                        }
                      ],
                      staticClass: "mr-4"
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "date_range" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("dateFormat")(_vm.file.fechaEntrega)) +
                          " "
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Fecha término del proceso",
                          expression: "'Fecha término del proceso'"
                        }
                      ],
                      staticClass: "mr-4"
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "event" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("dateFormat")(_vm.file.fechaRevicion)) +
                          " "
                      )
                    ],
                    1
                  ),
                  _vm.file.plazo
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Tiempo transcurrido",
                              expression: "'Tiempo transcurrido'"
                            }
                          ],
                          attrs: { color: "primary", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "access_time" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.translateTime(_vm.file.plazo, true)) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.emisorInfoAdicional
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Unidad",
                              expression: "'Unidad'"
                            }
                          ],
                          attrs: { color: "success", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "group" } }),
                          _vm._v(
                            " " + _vm._s(_vm.file.emisorInfoAdicional) + " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.privado === "Y"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "archivo privado",
                              expression: "'archivo privado'"
                            }
                          ],
                          attrs: { color: "warning", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "lock" } }),
                          _vm._v(" privado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.oficinaNombre
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Oficina",
                              expression: "'Oficina'"
                            }
                          ]
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "approval" } }),
                          _vm._v(" " + _vm._s(_vm.file.oficinaNombre) + " ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.file.numeroReferencia
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Numero Referencia",
                              expression: "'Numero Referencia'"
                            }
                          ]
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "tag" } }),
                          _vm._v(" " + _vm._s(_vm.file.numeroReferencia) + " ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-lg": "1",
            "vs-type": "flex",
            "vs-justify": "center",
            "vs-align": "center"
          }
        },
        [
          _c("FileOptions", {
            attrs: { file: _vm.file, "select-file": _vm.selectFile }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }